import { City } from 'proto/City';
import { Region as ProtoRegion } from 'proto/Region';

export enum LocationFilterType {
    City = 'city',
    Region = 'region',
}

export interface Region extends ProtoRegion {
    cityList: City[];
}

export interface ListItem {
    id: number;
    name: string;
}

export type CityList = City[];

export type RegionList = Region[];

export interface LocationFilterData {
    cityList?: CityList;
    regionList?: RegionList;
}
